const environment = process.env.NODE_ENV || 'development';

const uri = environment === 'development' ? "https://bs.olawa.pl.demo:8890/" : "https://bs.olawa.pl/";


const Config = {
    url: `${uri}`,
    urlApi: `${uri}api`,
    urlPublic: `${uri}media`,
    options: [
        { value: 1, name: "Kredyt dla osoby fizycznej" },
        { value: 2, name: "Kredyt dla firmy" },
        { value: 3, name: "Kredyt rolniczy" },
        { value: 4, name: "Konto osobiste" },
        { value: 5, name: "Konto firmowe" },
        { value: 6, name: "Konto rolnicze" },
        { value: 7, name: "Leasing" },
        { value: 8, name: "Pomoc" }
    ],
    optionsLoanDay: [
        { value: 1, name: "5-ty dzień miesiąca" },
        { value: 2, name: "10-ty dzień miesiąca" },
        { value: 3, name: "15-ty dzień miesiąca" },
        { value: 4, name: "20-ty dzień miesiąca" },
        { value: 5, name: "25-ty dzień miesiąca" },
        { value: 6, name: "30-ty dzień miesiąca" },
    ],
    optionsSimple: [
        { value: 1, name: "Nie" },
        { value: 2, name: "Tak" },
    ],
    optionsMarital: [
        { value: 1, name: "Kawaler/panna" },
        { value: 2, name: "Żonaty/zamężna" },
        { value: 3, name: "Rozwiedziony/Rozwiedziona"},
        { value: 4, name: "Wdowiec/Wdowa"}
    ],
    optionsIncome: [
        { value: 1, name: "Umowa o pracę" },
        { value: 2, name: "Działalność gospodarcza / rolnicza" },
        { value: 3, name: "Emerytura / renta" },
        { value: 4, name: "Inne" }
    ],
    optionsAbout: [
        { value: 1, name: "Reklama internetowa" },
        { value: 2, name: "Od znajomych" },
        { value: 3, name: "SMS" },
        { value: 4, name: "Bankowość internetowa" },
    ],
    optionsContact: [
        { value: 1, name: "9:00 - 12:00" },
        { value: 2, name: "12:00 - 16:30" },
    ],
    optionsTopicSpecial: [
        { value: 1, name: "Informacje o ofercie banku" },
        { value: 2, name: "Bankowość mobilna i internetowa" },
        { value: 3, name: "Kredyty" },
        { value: 4, name: "Rachunki" },
        { value: 5, name: "Inne" },
    ],

}

export default Config
